export default "__VITE_ASSET__BXzNPA9u__"